import { Component, OnInit, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { ToastsManager, } from 'ng2-toastr/ng2-toastr';
import { ProfileService } from '../profile.service';
import * as Globals from '../globals';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @Output() setLogin = new EventEmitter();
  userId: string;
  loading: boolean;
  password: string;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private profileService: ProfileService, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
  }

  login() {
    if (this.userId && this.password) {
      var data = 'grant_type=password&username=' + this.userId + '&password=' + this.password + '&client_id="bisoft"';
      let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      this.loading = true;
      this.http.post(Globals.serviceUrl + 'token', data, { headers: headers })
        .subscribe((res: Response) => {
          sessionStorage.setItem('authorizationData','{ "token": "' + res.json().access_token + '", "userName": "' + this.userId + '", "refreshToken": "' + res.json().refresh_token + '", "useRefreshTokens": false }');
          this.profileService.token = res.json().access_token;
          this.profileService.userName = this.userId;
          this.profileService.isLogin = true;
          //this.getUserProfile(res.json().access_token);
          sessionStorage.setItem('profile',res.json().profile);
          var profile = JSON.parse(res.json().profile);
          if(profile.PARENT_GROUP_ID >= 3 && profile.PARENT_GROUP_ID <= 5){
            this.router.navigate(['/dashboard']);
          }
          else
          {
            this.router.navigate(['/dashboardonline']);
          }
          
        }, err => {
          console.log(err);
          if (err.status == 400) {
            this.toastr.error(err.json().error_description);
          } else {
            this.toastr.error(Globals.errorMessage(err));
          }
          this.loading = false;
        });
    } else {
      this.toastr.error("User Id dan password tidak boleh kosong");
    }

  }
  getUserProfile(token: any) {
    let headers = new Headers({ 'Authorization': 'Bearer ' + token });
    var tokenData = { TOKEN: token };
    this.http.put(Globals.serviceUrl + 'ref/usertoken?username=' + this.userId, tokenData, { headers: headers })
      .subscribe((res) => {
        this.http.get(Globals.serviceUrl + 'ref/user?token=' + token + '&username=' + this.userId + '&t=' + new Date().getTime(), { headers: headers })
          .subscribe((res) => {
            var profile = JSON.parse(res.json().PROFILE);
            sessionStorage.setItem('profile',JSON.stringify(profile));
            this.toastr.success('Selamat datang ' + profile.FULLNAME);
            this.router.navigate(['/dashboard']);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/login/login.component.ts